export const Type_ClipboardTransition = 'clipboard-transition';
export const Type_ClipboardTransitionOrders = 'clipboard-transition-orders';
export const TransitionCondition = {
    BEFORE_RES_FUNC: 'before_resolution_function',
    MISSING_HVS: 'missing_hvs',
    RES_FUNC_TRUE: 'res_func_true',
    RES_FUNC_FALSE: 'res_func_false',
    EVAL_FAILURE: 'evaluation_failure',
    GO_TO_TRANSITION: 'go_to_transition',
    ACTIVATED: 'activated',
};
export const generateNewTransition = (pathwayId, sourceId, targetId) => {
    return {
        label: 'New Transition',
        sourceId,
        targetId,
        pathwayIds: [pathwayId],
        dds: [],
        resolutionFunction: {},
        priorityIndex: 0,
    };
};
//# sourceMappingURL=consts.js.map